export default __webpack_public_path__ + "static/media/back-arrow.58db4625.svg";